import React, { useCallback, useState } from 'react';
import Loader from 'react-loader-spinner';
import styled from 'styled-components';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Input, Prompt, remInPx, Select } from './../../ui';

const TextArea = styled.textarea`
    display: block;
    position: relative;
    width: 100%;
    border-radius: 0.375rem;
    appearance: none;
    background-color: #ffffff;
    border-color: #d2d6dc;
    border-width: 1px;
    border-radius: 0.375rem;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
`;

const tm = (key: string, label: string) => ({ key, label });
const feedbackTypes = [
    tm('issue', 'Issue / Bug'),
    tm('question', 'Question'),
    tm('suggestion', 'Suggestion'),
    tm('template', 'Template Idea'),
    tm('other', 'Other'),
];

export const FeedbackPopup: LFC<PopupProps> = ({ action, dismiss }) => {

    const api = useResolve(ApiClient);
    const [working, setWorking] = useState(false);
    const [type, setType] = useState<any>(feedbackTypes[0]);
    const [message, setMessage] = useState<string>();

    const invalid = !type || !message;

    const onSubmit = useCallback(async () => {
        if (working) return;
        setWorking(true);
        action(await api.exec(v2.me.feedback({ type, message })));
    }, [action, working, type, message]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onSubmit();
    }, [invalid, onSubmit]);

    return <Prompt ignoreEnter onAction={working ? null : onPromptAction}>
        <Popup w={48}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Submit Feedback</Popup.Title>
            <Popup.Content>
                Please submit your feedback, bug report or question using the form below.
                We will reply to your email if an reply is appropriate.
                We appreciate any all all feedback, especially reports of bugs or glitches, so thank you in advance!
                <Spacer f={2} />
                <Input.Label style={{ marginBottom: '.5rem' }}>Type</Input.Label>
                <Select items={feedbackTypes} selected={type} onChange={setType} />
                <Spacer f={2} />
                <Input.Label>Message</Input.Label>
                <TextArea
                    rows={10}
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={() => onSubmit()}>
                    {working ? 'Submitting' : 'Submit'}
                    &nbsp;
                    {working && <>
                        &nbsp;
                        <Loader
                            type="TailSpin"
                            color="#fff"
                            height={remInPx(1.2)}
                            width={remInPx(1.2)}
                        />
                    </>}
                </Button>
                <Button disabled={working} variant="common" onAction={dismiss}>
                    Cancel
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
